/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 *
 * @file OnboardingPromotionPanel.jsx
 * Promotional / value-prop panel with feature list and CTA.
 * @author Anuja Gaikwad
 * @since 2.0.0
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import Icon from '../icons/Icon';
import { classes } from './styles/OnboardingSplashStyles';

const OnboardingPromotionPanel = ({
  title,
  features,
  learnMoreLabel,
  onLearnMoreClick
}) => (
  <section className={classes.promotionPanel}>
    <Typography
      component="h2"
      className={`${classes.panelTitle} ${classes.promotionTitle}`}
    >
      {title}
    </Typography>

    <div className={classes.promotionBody}>
      <ul className={classes.featureList}>
        {features.map((feature) => (
          <li key={feature} className={classes.featureItem}>
            <span className={classes.featureIcon}>
              <Icon name="OnboardingFeatureCheckIcon" />
            </span>
            <Typography component="p" className={classes.featureText}>
              {feature}
            </Typography>
          </li>
        ))}
      </ul>

      <button
        type="button"
        className={classes.learnMoreButton}
        onClick={onLearnMoreClick}
      >
        {learnMoreLabel}
      </button>
    </div>
  </section>
);

OnboardingPromotionPanel.propTypes = {
  title: PropTypes.string.isRequired,
  features: PropTypes.arrayOf(PropTypes.string).isRequired,
  learnMoreLabel: PropTypes.string.isRequired,
  onLearnMoreClick: PropTypes.func
};

OnboardingPromotionPanel.defaultProps = {
  onLearnMoreClick: () => {}
};

export default OnboardingPromotionPanel;
